import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TableNoResults } from '@ui/v2/Table/Table'

interface Props {
  hasActiveFilters: boolean
}

export const TransactionHistoryEmptyState: FC<Props> = ({ hasActiveFilters }) => {
  const { t } = useTranslation()

  if (hasActiveFilters) {
    return (
      <TableNoResults
        title={t('No matching transactions')}
        content={t('Try adjusting your filters to see more results.')}
      />
    )
  }

  return (
    <TableNoResults
      title={t('No transactions yet')}
      content={t('Transactions will appear here once available.')}
    />
  )
}
